<section class="stats-panel">

  @if (loading()) {
    <div class="skeleton-grid">
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="skeleton-tile"></div>
      }
    </div>
  } @else if (error()) {
    <div class="empty-state">
      <span class="empty-icon">◌</span>
      <p class="empty-title">Statistika trenutno nije dostupna</p>
      <span class="empty-sub">Pokušaj ponovno malo kasnije.</span>
    </div>
  } @else {
    @if (statistics(); as stats) {

    <header class="panel-header">
      <span class="eyebrow">Pregled vožnji</span>
      <h2 class="panel-title">Statistika vožnje</h2>
    </header>

    <div class="tiles-wrap">
      <svg class="route-line" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,10 C10,2 15,18 25,10 S40,2 50,10 S65,18 75,10 S90,2 100,10" />
      </svg>

      <div class="tile">
        <span class="waypoint"></span>
        <span class="tile-value">{{ stats.routeCount }}</span>
        <span class="tile-label">Broj ruta</span>
      </div>

      <div class="tile">
        <span class="waypoint"></span>
        <span class="tile-value">{{ stats.rideCount }}</span>
        <span class="tile-label">Broj vožnji</span>
      </div>

      <div class="tile">
        <span class="waypoint"></span>
        <span class="tile-value">{{ totalDistanceKm() }}<span class="unit">km</span></span>
        <span class="tile-label">Prijeđeno kilometara</span>
      </div>

      <div class="tile">
        <span class="waypoint"></span>
        <span class="tile-value">{{ totalTimeFormatted() }}</span>
        <span class="tile-label">Ukupno vrijeme</span>
      </div>
    </div>

    @if (stats.routeWithBiggestAverageSpeed && recordAverageSpeed()) {
      <div class="record-panel record-panel--clickable" [routerLink]="['/route-details', stats.routeWithBiggestAverageSpeed.id]" role="button" tabindex="0">
        <div class="record-label">
          <span class="record-icon">⚡</span>
          <span>Najveća prosječna brzina</span>
        </div>
        <div class="record-value">
          {{ recordAverageSpeed() }}<span class="unit">km/h</span>
        </div>
        <div class="record-meta">Zabilježeno {{ recordRouteDate() }}</div>
      </div>
    } @else {
      <div class="record-panel record-panel--empty">
        <span>Rekord brzine još nije zabilježen</span>
      </div>
    }
    }

  }

</section>